export default __webpack_public_path__ + "686ab15f38f908ef47bfb208a9de2896.jpg";